export function mapCashout(data) {
    return {
        informations: mapInformaitons(data[0]),
        operations: mapOperationsPull(data[1]),
    };
}
function mapInformaitons(data) {
    const mappedInformation = {};
    for (const [informationid, informationArray] of Object.entries(data)) {
        mappedInformation[informationid] = mapInformation(informationArray);
    }
    return mappedInformation;
}
export function mapOperationsPull(data) {
    const mappedOperation = {};
    for (const [operationnid, operationArray] of Object.entries(data)) {
        mappedOperation[operationnid] = mapOperationResult(operationArray);
    }
    return mappedOperation;
}
function mapInformation(data) {
    return {
        betId: data[0],
        purchaseId: data[1],
        cashOutEnabled: data[2],
        partialCashOutEnabled: data[3],
        minPartialReturn: data[4],
        maxPartialReturn: data[5],
        fullReturn: data[6],
        cashOutStatus: data[7],
    };
}
export function mapInformationMessage(data) {
    return {
        betId: data[0],
        purchaseId: data[1],
        cashOutEnabled: data[2],
        partialCashOutEnabled: data[3],
        minPartialReturn: data[4],
        maxPartialReturn: data[5],
        fullReturn: data[6],
        cashOutStatus: data[7],
    };
}
function mapOperation(data) {
    return {
        cashOutInformation: mapInformationMessage(data[0]),
        cashOutAmount: data[1],
    };
}
export function mapOperationResult(data) {
    return {
        cashOutOperation: mapOperation(data[0]),
        status: data[1],
        declineReason: data[2],
        statusUpdateTime: data[3],
        delayPeriod: data[4],
        newOfferId: data[5],
    };
}
//# sourceMappingURL=mapCashout.js.map